import { ApiObterUnidadeLotacao } from '@/api'
import { defineStore } from 'pinia'

export const UnidadesLotacoes = defineStore('UnidadesLotacoes', {
   state: () => ({
      unidadeLotacao: null
   }),
   actions: {
      async ActionObterUnidadeLotacao() {
         await ApiObterUnidadeLotacao().then((resposta) => (this.unidadeLotacao = resposta))
      }
   }
})
